var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1637 6.28791L8.16374 16.2879C8.07664 16.3753 7.97315 16.4447 7.85919 16.492C7.74524 16.5393 7.62306 16.5636 7.49967 16.5636C7.37628 16.5636 7.25411 16.5393 7.14016 16.492C7.0262 16.4447 6.92271 16.3753 6.83561 16.2879L2.46061 11.9129C2.3734 11.8257 2.30423 11.7222 2.25703 11.6082C2.20984 11.4943 2.18555 11.3722 2.18555 11.2488C2.18555 11.1255 2.20984 11.0034 2.25703 10.8895C2.30423 10.7755 2.3734 10.672 2.46061 10.5848C2.54782 10.4976 2.65134 10.4284 2.76528 10.3812C2.87922 10.334 3.00135 10.3097 3.12467 10.3097C3.248 10.3097 3.37012 10.334 3.48406 10.3812C3.598 10.4284 3.70153 10.4976 3.78874 10.5848L7.50045 14.2965L16.8372 4.96134C17.0133 4.78522 17.2522 4.68628 17.5012 4.68628C17.7503 4.68628 17.9892 4.78522 18.1653 4.96134C18.3414 5.13746 18.4404 5.37633 18.4404 5.62541C18.4404 5.87448 18.3414 6.11335 18.1653 6.28947L18.1637 6.28791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckIcon);
export default __webpack_public_path__ + "static/media/whiteCheckIcon.30b0d97f018ff83cd9989a7be84b2050.svg";
export { ForwardRef as ReactComponent };